import { __makeTemplateObject } from '../../../../node_modules/tslib/tslib.es6.js';
import styled from 'styled-components';
import { color } from '../../../styles/styles.js';
import Alert from '../Alert/alert.js';
import '../Alert/index.js';
var ToastContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  ", "\n\n  z-index:99;\n"], ["\n  position: fixed;\n  ", "\n\n  z-index:99;\n"])), function (props) {
  var position = '';

  switch (props.position) {
    case 'top':
      position = "\n            top:20px;\n            left: 50%;\n            transform: translateX(-50%);\n            width: 500px;\n            @media (max-width: 500px) {\n              width: calc(100% - 20px);\n            }\n            ";
      break;

    case 'bottom':
      position = "\n             bottom:20px;\n            left: 50%;\n            transform: translateX(-50%);\n            width: 500px;\n            @media (max-width: 500px) {\n              width: calc(100% - 20px);\n            }\n            ";
      break;

    case 'bottom-right':
      position = "\n        bottom:20px;\n        right:20px;\n        width: 300px;\n            ";
      break;

    case 'top-right':
    default:
      position = "\n        top:20px;\n        right:20px;\n        width: 300px;\n\n            ";
  }

  return [position];
});
var StyledToast = styled(Alert)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: 10px;\n  transition: all;\n  position: relative;\n  border-radius: 5px;\n  animation: ", ";\n  @keyframes fadeinToast {\n    0% {\n      transform: scale(0);\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n      transform: scale(1);\n    }\n  }\n\n  @keyframes fadeoutToast {\n    0% {\n      transform: scale(1);\n      opacity: 1;\n    }\n    100% {\n      opacity: 0;\n      transform: scale(0);\n    }\n  }\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);\n"], ["\n  margin-bottom: 10px;\n  transition: all;\n  position: relative;\n  border-radius: 5px;\n  animation: ", ";\n  @keyframes fadeinToast {\n    0% {\n      transform: scale(0);\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n      transform: scale(1);\n    }\n  }\n\n  @keyframes fadeoutToast {\n    0% {\n      transform: scale(1);\n      opacity: 1;\n    }\n    100% {\n      opacity: 0;\n      transform: scale(0);\n    }\n  }\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);\n"])), function (props) {
  return !props.removing ? 'fadeinToast 0.5s ease-in-out' : 'fadeoutToast 0.5s ease-in-out';
});
var LoadingBar = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  height: 5px;\n  transition: all;\n  margin-top: 10px;\n  background-color: ", ";\n  width: ", "%;\n"], ["\n  position: relative;\n  height: 5px;\n  transition: all;\n  margin-top: 10px;\n  background-color: ", ";\n  width: ", "%;\n"])), function (props) {
  switch (props.fcStyle) {
    case 'danger':
      return color.danger;

    case 'warning':
      return color.warning;

    case 'info':
      return color.info;

    case 'success':
      return color.success;

    default:
      return props.theme === 'dark' ? color.medium : color.light;
  }
}, function (props) {
  return props.timer;
});
var CloseButton = styled.button(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: 0px;\n  border: none;\n  color: ", ";\n  background-color: transparent;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 12px;\n  cursor: pointer;\n  &:hover {\n    color: ", ";\n  }\n"], ["\n  padding: 0px;\n  border: none;\n  color: ", ";\n  background-color: transparent;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 12px;\n  cursor: pointer;\n  &:hover {\n    color: ", ";\n  }\n"])), color.medium, color.mediumdark);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
export { CloseButton, LoadingBar, StyledToast, ToastContainer };